export class ReportDataHelper {

    constructor(reportsActions) {
        this.clearFormFunctions = {};
        this.validateFormFunctions = {};
        this.toFormMappers = {};
        this.toApiRequestMappers = {};
        this.reportsActions = reportsActions;
    }


    registerReportFilterFunctions = (
        reportId,
        clearFormFunction,
        validateFormFunction,
        toFormMapperFunction,
        toApiRequestMapperFunction
    ) => {
        const id = reportId.toString();
        if (clearFormFunction && typeof clearFormFunction === 'function') {
            this.clearFormFunctions[id] = clearFormFunction;
        }
        if (validateFormFunction && typeof validateFormFunction === 'function') {
            this.validateFormFunctions[id] = validateFormFunction;
        }
        if (toFormMapperFunction && typeof toFormMapperFunction === 'function') {
            this.toFormMappers[id] = toFormMapperFunction;
        }
        if (toApiRequestMapperFunction && typeof toApiRequestMapperFunction === 'function') {
            this.toApiRequestMappers[id] = toApiRequestMapperFunction;
        }
    }

    clearForm = (reportId) => {
        const id = reportId.toString();
        const func = this.clearFormFunctions[id];
        if (func && typeof func === 'function') {
            func();
        }
    }

    validateForm = (reportId) => {
        const id = reportId.toString();
        const func = this.validateFormFunctions[id];
        if (func && typeof func === 'function') {
            return func();
        }
    }

    mapToForm = (reportId, reportRequest) => {
        const id = reportId.toString();
        const func = this.toFormMappers[id];
        if (func && typeof func === 'function') {
            return func(reportRequest);
        }
    }

    mapToApiRequest = (reportId) => {
        const id = reportId.toString();
        const func = this.toApiRequestMappers[id];
        
        if (func && typeof func === 'function') {
            const { apiRequest, formValues } = func();
            // Save the form values to app state before returning the apiRequest
            this.reportsActions.saveReportFilterValues(reportId, formValues);
            return apiRequest;
        }
    }
}

export default ReportDataHelper;
